import { ContentLayout } from "@2u-landing-pages/components/ContentLayout";
import { Container } from "@red-digital/bricks";
import cn from "classnames";
import React from "react";

import { BentoItemGroup, BentoProps, CustomCSSProperties } from "../../Bento.types";
import { Tiles } from "../../Tiles";
// @ts-ignore
import styles from "./Inline.module.scss";

export const Inline: React.FC<BentoProps> = ({
  style,
  className,
  section_heading,
  items_group_one,
  items_group_two,
  items_group_three,
  embedded,
  variation,
  stack_heading = false,
  show_divider_line = false,
  show_background = true,
  divider_line_color,
  phoneNumber,
}) => {
  const groups = [items_group_one, items_group_two, items_group_three].filter((val) => val) as BentoItemGroup[];

  let customStyle: CustomCSSProperties = {
    ...style,
    ...(!show_background ? { "--extended-background-color": "transparent" } : {}),
  };

  const inlineStyle: CustomCSSProperties = {
    ...(!show_background ? { "--container-padding": "0" } : {}),
    ...(divider_line_color && stack_heading ? { "--divider-line-color": `var(${divider_line_color})` } : {}),
  };

  return (
    <Container className={cn({ [styles.asSection]: !embedded })} style={customStyle}>
      <Container
        flex
        direction="column"
        lg={{ direction: "row", wrap: stack_heading ? "wrap" : undefined }}
        className={cn(styles.inline, className)}
        style={inlineStyle}
      >
        {section_heading && (
          <ContentLayout
            className={cn(styles.headingContainer, {
              [styles.stackHeading]: stack_heading,
              [styles.showDividerLine]: show_divider_line && stack_heading,
            })}
            content={section_heading}
            heading={{
              className: styles.heading,
              variant: "heading-xl",
            }}
            phoneNumber={phoneNumber}
          />
        )}
        <Tiles
          variation={variation}
          embedded={embedded}
          groups={groups}
          phoneNumber={phoneNumber}
        />
      </Container>
    </Container>
  );
};
